// 时间格式化
let util = {
    timeHandle: function(time) {
        try {
            let hmsStr = time.split(' ')[1];
            let hmsArr = hmsStr.split(':');
            hmsArr.length = 2;
            return hmsArr.join(':');
        } catch (e) {
            return time;
        }
    },
    timeHandleNosecond: function(time) {
        try {
            return time.substring(0, time.lastIndexOf(':'));
        } catch (e) {
            return time;
        }
    },
    timeHandleDay: function(time) {
        try {
            return time.substring(0, time.lastIndexOf(' '));
        } catch (e) {
            return time;
        }
    },
    getDate: function(time) {
        return time
            .split(' ')[0]
            .split('-')
            .join('-');
    },
    handlesSroll: function(ele) {
        console.log(ele);
        if (ele.pageYOffset !== null) {
            // 支持IE9 +
            return {
                left: ele.pageXOffset,
                top: ele.pageYOffset
            };
        } else if (ele.compatMode === 'CSS1Compat') {
            return {
                left: ele.documentElement.scrollLeft,
                top: ele.documentElement.scrollTop
            };
        }
        return {
            left: ele.scrollLeft,
            top: ele.scrollTop
        };
    }
};

module.exports = util;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pagelist.mobile/app/modules/util/index.js